const SUPPORT_CHAT_USER_UUID_KEY = "fanrank:support-chat:user-uuid";

export function getSupportChatUserUUID() {
  if (typeof window === "undefined") {
    return crypto.randomUUID();
  }

  const existing = localStorage.getItem(SUPPORT_CHAT_USER_UUID_KEY)?.trim();
  if (existing) {
    return existing;
  }

  const userUUID = crypto.randomUUID();
  localStorage.setItem(SUPPORT_CHAT_USER_UUID_KEY, userUUID);
  return userUUID;
}
